<template>
  <main class="insights-page section-shell">
    <div class="site-container">
      <header class="page-hero">
        <p class="eyebrow">Publicaciones técnicas</p>
        <h1>Investigación aplicada y observaciones para operar con más control.</h1>
        <p class="page-hero__description">
          Análisis sobre brotes, contaminación cruzada, limpieza y resistencia antimicrobiana para equipos de calidad y dirección.
        </p>
      </header>

      <section v-if="featuredEntry" class="featured-article">
        <div class="featured-article__image">
          <OptimizedImage :src="featuredEntry.image" :alt="featuredEntry.title" />
        </div>
        <div class="featured-article__body">
          <p class="eyebrow">{{ featuredEntry.category }}</p>
          <h2>{{ featuredEntry.title }}</h2>
          <p>{{ featuredEntry.summary }}</p>
          <router-link :to="`/insights/${featuredEntry.slug}`" class="btn-primary">
            Leer destacado
          </router-link>
        </div>
      </section>

      <section class="category-section">
        <div v-for="group in categoryGroups" :key="group.name" class="category-group">
          <div class="category-group__header">
            <h2>{{ group.name }}</h2>
            <span>{{ group.entries.length }} artículos</span>
          </div>
          <div class="article-grid">
            <ArticleCard v-for="entry in group.entries" :key="entry.slug" :entry="entry" />
          </div>
        </div>
      </section>
    </div>
  </main>
</template>

<script>
import ArticleCard from '@/components/ArticleCard.vue';
import OptimizedImage from '@/pages/components/OptimizedImage.vue';
import { blogEntries } from '@/generated/blogEntries';
import { setSeoMeta } from '@/utils/seo';
import { normalizeEntry } from '@/utils/text';

export default {
  name: 'InsightsPage',
  components: {
    ArticleCard,
    OptimizedImage
  },
  computed: {
    featuredEntry() {
      return blogEntries[0] ? normalizeEntry(blogEntries[0]) : null;
    },
    categoryGroups() {
      const grouped = blogEntries.reduce((accumulator, entry) => {
        const normalized = normalizeEntry(entry);

        if (!accumulator[normalized.category]) {
          accumulator[normalized.category] = [];
        }
        accumulator[normalized.category].push(normalized);
        return accumulator;
      }, {});

      return Object.keys(grouped).map(name => ({
        name,
        entries: grouped[name]
      }));
    }
  },
  mounted() {
    setSeoMeta({
      title: 'Insights | JL Consultorías',
      description:
        'Explora artículos técnicos de JL Consultorías sobre inocuidad alimentaria, contaminación cruzada, brotes y control microbiológico.',
      url: `${window.location.origin}/insights`,
      image: `${window.location.origin}/img/logo-jl.png`
    });
  }
};
</script>

<style lang="scss" scoped>
.page-hero {
  max-width: 52rem;
  padding-top: 4rem;
  margin-bottom: 3rem;
}

.page-hero__description {
  color: var(--muted-color);
}

.featured-article {
  display: grid;
  gap: 0;
  margin-bottom: 3rem;
  background: var(--surface-color);
  border: 1px solid rgba(59, 73, 76, 0.7);
}

.featured-article__body {
  padding: 2rem;
}

.category-section {
  display: grid;
  gap: 3rem;
}

.category-group {
  display: grid;
  gap: 1.5rem;
}

.category-group__header {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 1rem;
  align-items: flex-end;
}

.category-group__header span {
  color: var(--muted-color);
  font-family: var(--font-mono);
  font-size: 0.78rem;
  text-transform: uppercase;
}

.article-grid {
  display: grid;
  gap: 1.5rem;
}

@media (min-width: 768px) {
  .article-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

@media (min-width: 992px) {
  .featured-article {
    grid-template-columns: minmax(0, 1.05fr) minmax(0, 0.95fr);
  }
}
</style>
